<template>
  <side-panel-inner headerTitle="Edit User" class="p-user-create" on-close='Users'>
    <template slot="actions">
      <dropdown class="u-show-mobile-only">
        <dropdown-action
          @click="deleteUser"
          v-if="$route.params.userId !== $store.state.auth.currentUser.id"
        >Delete</dropdown-action>
        <dropdown-action @click="updateUser">Save</dropdown-action>
        <dropdown-action
          @click="blockUser"
          v-if="$route.params.userId !== $store.state.auth.currentUser.id && !$store.state.users.currentUser.blocked"
        >Block</dropdown-action>
        <dropdown-action
          @click="unblockUser"
          v-else-if="$route.params.userId !== $store.state.auth.currentUser.id && $store.state.users.currentUser.blocked"
        >Unblock</dropdown-action>
      </dropdown>
      <base-button
        @click="deleteUser"
        danger
        v-if="$route.params.userId !== $store.state.auth.currentUser.id"
        class="u-hide-mobile"
      >Delete</base-button>
      <base-button @click="updateUser" :primary="true" class="u-hide-mobile">Save</base-button>
      <base-button
        @click="blockUser"
        v-if="$route.params.userId !== $store.state.auth.currentUser.id && !$store.state.users.currentUser.blocked"
        class="u-hide-mobile"
      >Block</base-button>
      <base-button
        @click="unblockUser"
        v-else-if="$route.params.userId !== $store.state.auth.currentUser.id && $store.state.users.currentUser.blocked"
        class="u-hide-mobile"
      >Unblock</base-button>
    </template>

    <!-- User Name -->
    <message type="error" v-if="showValidationMessage">
      <h3>Form Invalid</h3>
      <p>Form is invalid, please check and try again.</p>
    </message>

    <user-form v-if="!loading"></user-form>

    <loading v-if="loading"></loading>
  </side-panel-inner>
</template>

<script>
const Dropdown = () => import("@/components/Dropdown");
const DropdownAction = () => import("@/components/DropdownAction");
import UserForm from "./UserForm";

export default {
  name: "user-edit",

  data() {
    return {
      showValidationMessage: false,
      loading: false,
      formReady: false
    };
  },

  beforeCreate() {
    const userid = this.$route.params.userId;

    this.$store
      .dispatch("users/read", { userid, setCurrent: true })
      .then(resp => {
        this.formReady = true;
      });
  },

  methods: {
    updateUser() {
      const vm = this;
      this.$validator.validate().then(result => {
        if (!result) {
          vm.validationFailed = true;
        } else {
          vm.$store.dispatch("users/updateUser").then(() => {
            vm.$store.dispatch("CLOSE_PANEL");
          });
        }
      });
    },

    deleteUser() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        confirm: () => {
          vm.$store
            .dispatch("users/delete", vm.$route.params.userId)
            .then(() => {
              // vm.$store.dispatch("CLOSE_PANEL");
            });
        }
      });
    },

    blockUser() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        confirm: () => {
          vm.$store
            .dispatch("users/blockUser", vm.$route.params.userId)
            .then(() => {
              // vm.$store.dispatch("CLOSE_PANEL");
            });
        }
      });
    },
    unblockUser() {
      const vm = this;
      this.$store.dispatch("createDialog", {
        confirm: () => {
          vm.$store
            .dispatch("users/unblockUser", vm.$route.params.userId)
            .then(() => {
              // vm.$store.dispatch("CLOSE_PANEL");
            });
        }
      });
    }
  },

  computed: {
    formIsValid() {
      return this.user.name;
    }
  },

  components: {
    UserForm,
    Dropdown,
    DropdownAction
  }
};
</script>
